import { Card, Modal } from 'antd';
import { DataFeedConfigurationFormTabs } from './DataFeedFormTabs';

type CreateDataFeedModalProps = {
  open: boolean;
  onExit: () => void;
  teamName: string;
  idTeam: string;
};

export const CreateDataFeedModal = ({
  open,
  onExit,
  teamName,
  idTeam,
}: CreateDataFeedModalProps) => {
  return (
    <Modal
      open={open}
      onCancel={onExit}
      footer={null}
      width="90%"
      title="Create new data feed"
      destroyOnClose
    >
      <Card className="w-full" bordered={false}>
        <DataFeedConfigurationFormTabs
          teamName={teamName}
          idTeam={idTeam}
          onExit={onExit}
        />
      </Card>
    </Modal>
  );
};
